import { ApolloProvider } from "@apollo/client";
import React from "react";
import { graphqlClient } from "../graphql";
import AppLoaderProvider from "./AppLoaderProvider";
import GridStateProvider from "./GridStateProvider";

const Providers: React.FC = ({ children }) => {
  return (
    <ApolloProvider client={graphqlClient}>
      <AppLoaderProvider loading={true}>
        <GridStateProvider>{children}</GridStateProvider>
      </AppLoaderProvider>
    </ApolloProvider>
  );
};

export default Providers;
